import { IonButton, IonLabel, IonToast } from '@ionic/react'
import React, { BaseSyntheticEvent, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import BadgeComponent from '../badge/Badge.component'
import CurrentTimeButton from '../currentTimeButton/CurrentTimeButton.component'
import Timer from '../timer/Timer.component'
import './QuickActionButton.component.css'
import { IQuickActionButton } from '../../features/quickActions/store/quickActions.types'
import { useTranslation } from 'react-i18next'
import { ToastColor } from '../toast/store/toast.constants'
import { getToastProps } from '../toast/toastIcon.util'
import { useDarkMode } from '../../hooks/useDarkMode'

const QuickActionButton: React.FC<IQuickActionButton> = (props: IQuickActionButton) => {
  const {
    showCount,
    count,
    timer,
    startTime,
    savedTime,
    timerDirection,
    currentTime,
    label,
    title2,
    action,
    color,
    size,
    fill,
    expand,
    showFlash,
    flashColor,
    flashTimes,
    id,
    disabled,
    savedTimeString,
    maxTimes,
    buttonId,
    showToastMessage,
  } = props

  const dispatch = useDispatch()
  const [showToast, setShowToast] = useState(false)
  const { t } = useTranslation()

  const darkMode = useDarkMode()

  useEffect(() => {
    if (count > 0) {
      setShowToast(true)
    }
  }, [count])

  useEffect(() => {
    const el = document.getElementById(`quick-action-button-label-${id}`)
    if (el) {
      el.style.setProperty('--border-style', 'solid')
      el.style.setProperty('--border-width', '0.5px')
      el.style.setProperty('--border-color', disabled ? '#fff' : color ? color : '#3682c2') // zoll blue
    }
  }, [disabled, color])

  useEffect(() => {
    const el = document.getElementById(`quick-action-button-label-${id}`)
    if (!disabled && count != 0) {
      if (el) {
        if (darkMode) {
          el.style.setProperty('--ion-color-light', '#383A3E')
        } else {
          el.style.setProperty('--ion-color-light', '#DFEEFB')
        }
      }
    }
  }, [count, darkMode])

  const clickAction = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    dispatch({ type: action, payload: id })
  }

  return (
    <div className={disabled ? 'disabled quick-action-button' : 'quick-action-button'}>
      <div>
        {timer && (
          <Timer
            disabled={disabled}
            startTime={startTime}
            savedTime={savedTime}
            timerDirection={timerDirection}
            showCount={showCount}
            count={count}
            color={color ? color : 'zoll-blue'}
            showFlash={showFlash}
            flashColor={flashColor ? flashColor : ''}
            flashTimes={flashTimes ? flashTimes : undefined}
            action={action}
            maxTimes={maxTimes}
            buttonId={buttonId}
          />
        )}
        {currentTime && <CurrentTimeButton color={color ? color : 'zoll-blue'} />}
        {!timer && showCount && (
          <>
            <IonButton
              disabled={disabled}
              class='count-timer'
              onClick={clickAction}
              color={color ? color : 'zoll-blue'}>
              {showCount && <BadgeComponent count={count} color={disabled ? 'red' : 'white'} />}
            </IonButton>
            {showToastMessage && title2 && (
              <IonToast
                isOpen={showToast}
                message={label + ' ' + title2 + t('quickActions.toastLabel')}
                {...getToastProps(ToastColor.Success)}
                duration={2000}
                onDidDismiss={() => setShowToast(false)}
              />
            )}
            {showToastMessage && !title2 && (
              <IonToast
                isOpen={showToast}
                message={t(`${label} 'quickActions.toastLabel'`)}
                {...getToastProps(ToastColor.Success)}
                duration={2000}
                onDidDismiss={() => setShowToast(false)}
              />
            )}
          </>
        )}
      </div>
      <IonButton
        className='quick-action-button-labels'
        id={`quick-action-button-label-${id}`}
        disabled={disabled}
        onClick={clickAction}
        color={disabled ? 'grey' : 'light'}
        size={size ? size : 'large'}
        fill={fill ? fill : 'solid'}
        expand={expand ? expand : 'block'}
        data-testid={`QuickActionButton${id}`}>
        <div>
          <IonLabel>{label}</IonLabel>
          {title2 && <p>{title2}</p>}
          {savedTimeString && <IonLabel data-testid={`QuickActionSavedTime${id}`}>{savedTimeString}</IonLabel>}
        </div>
      </IonButton>
      {showToastMessage && title2 && (
        <IonToast
          isOpen={showToast}
          message={label + ' ' + title2 + t('quickActions.toastLabel')}
          {...getToastProps(ToastColor.Success)}
          duration={2000}
          onDidDismiss={() => setShowToast(false)}
        />
      )}
      {showToastMessage && !title2 && (
        <IonToast
          isOpen={showToast}
          message={label + t('quickActions.toastLabel')}
          {...getToastProps(ToastColor.Success)}
          duration={2000}
          onDidDismiss={() => setShowToast(false)}
        />
      )}
    </div>
  )
}

export default QuickActionButton
